/**
 * Hinweis, dass im Hintergrund noch Referenz-Angebote analysiert werden (Automatik P4.4).
 *
 * Zwei Dinge in einem Satz, und beide sind wichtig: der Fortschritt IST hier sichtbar, und er
 * haelt NICHTS auf. Ein Angebot muss auch ohne fertiges Stilprofil entstehen koennen (Konzept
 * §3.6) - sonst wuerde die neue Automatik die Kernarbeit ausbremsen, statt sie zu erleichtern.
 * Deshalb ein ruhiger Hinweis und kein Sperrbalken, kein Spinner ueber dem Formular, kein
 * deaktivierter Knopf. Ist nichts in Arbeit, ist hier gar nichts.
 */
import { Icon } from "./components";
import { useReferenceProgress } from "./ReferenceProgressProvider";

export function ReferenzAnalyseHinweis() {
  const { progress, running } = useReferenceProgress();
  if (!running || !progress) return null;
  const offen =
    progress.catering.uploaded + progress.catering.extracting + progress.event.uploaded + progress.event.extracting;
  return (
    <p className="flex items-center gap-2 rounded-lg bg-primary/8 p-3 font-body-sm text-body-sm text-on-background dark:text-inverse-on-surface">
      <Icon name="progress_activity" className="animate-spin text-[18px]" />
      <span>
        {offen === 1 ? "Eine Referenz wird noch analysiert" : `${offen} Referenzen werden noch analysiert`} — das
        Angebot lässt sich trotzdem fertigstellen. Ein Stilprofil wirkt erst, wenn Sie es aktivieren.
      </span>
    </p>
  );
}
